import Prism from "prismjs";
import "prismjs/components/prism-markup.min";
import "prismjs/components/prism-markup-templating.min";
import "prismjs/components/prism-c.min";
import "prismjs/components/prism-clike.min";
import "prismjs/components/prism-javascript.min";
import "prismjs/components/prism-json.min";
import "prismjs/components/prism-typescript.min";
import "prismjs/components/prism-jsx.min";
import "prismjs/components/prism-sql.min";
import "prismjs/components/prism-python.min";
import "prismjs/components/prism-go.min";
import "prismjs/components/prism-ruby.min";
import "prismjs/components/prism-rust.min";
import "prismjs/components/prism-elixir.min";
import "prismjs/components/prism-php.min";
import "prismjs/components/prism-perl.min";
import "prismjs/components/prism-java.min";
import "prismjs/components/prism-kotlin.min";
import "prismjs/components/prism-yaml.min";
import "prismjs/components/prism-dot.min";
import "prismjs/components/prism-bash.min";
import "prismjs/components/prism-gherkin.min";
import "prismjs/components/prism-regex.min";
import "prismjs/components/prism-swift.min";
import "prismjs/components/prism-objectivec.min";
import "prismjs/components/prism-nginx.min";
import "prismjs/components/prism-apacheconf.min";
import "prismjs/components/prism-docker.min";
import "prismjs/components/prism-ini.min";
import "prismjs/components/prism-ignore.min";
import "prismjs/components/prism-csharp.min";

export const highlightedCode = (language, code) => {
  if (!code) {
    return code;
  }

  if (!Prism.languages[language]) {
    language = "plain";
  }

  return Prism.highlight(code, Prism.languages[language], language);
};

export const highlightCodeInContent = (body) => {
  if (!body) {
    return body;
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(body, "text/html");
  doc.querySelectorAll("pre").forEach((element) => {
    const language = element.getAttribute("data-language") || "none";
    const code = element.querySelector("code");

    if (code) {
      const codeContent = code?.textContent;
      element.innerHTML = highlightedCode(language, codeContent);
    }
  });

  return doc.body.innerHTML;
};
